import { SectionHeader } from "./section-header"

const personas = [
  {
    icon: "🏋️",
    title: "Treinadores e personais",
    desc: "Crie treinos com estímulos para agilidade e tempo de reação. Da academia ao alto rendimento, acompanhe a evolução de cada aluno.",
  },
  {
    icon: "📚",
    title: "Professores e educadores",
    desc: "Leve estímulos para a aula ou a escolinha. Desenvolva foco, raciocínio rápido e movimento, com dados de evolução.",
  },
  {
    icon: "🩺",
    title: "Fisioterapeutas",
    desc: "Use estímulos para treinar reação e atenção. Marque acertos, tempos e avance com dados reais.",
  },
]

export function ForWhom() {
  return (
    <section id="para-quem" className="py-24 md:py-32 bg-card/20">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeader
          eyebrow="Para quem é"
          title={<>Feito para quem trabalha com <span className="text-primary">movimento e aprendizagem</span></>}
        />

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {personas.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl bg-card border border-white/5 p-8 hover:border-primary/30 hover:-translate-y-1 transition-all relative overflow-hidden group"
            >
              <div
                className="absolute -top-10 -right-10 h-40 w-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity blur-3xl"
                style={{ background: "rgba(0,255,179,0.2)" }}
              />
              <div className="text-6xl mb-5 relative">{p.icon}</div>
              <h3 className="text-2xl font-bold mb-3 relative">{p.title}</h3>
              <p className="text-muted-foreground leading-relaxed relative">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
